'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var UNKNOWN = '?';

/**
 * Gets initials from name string
 * If 2 words or more words are available, use the first character of first 2 words as initials.
 * If only 1 word is available, just use the first character as a single character initial.
 * If nothing is available or empty string, just throw a question mark '?' character.
 * @param {string} name 
 */
var getInitials = exports.getInitials = function getInitials(name) {
  if (!name) {
    return UNKNOWN;
  }

  var nameArr = name.split(' ');

  var result = '';

  for (var i = 0; i < nameArr.length; i++) {
    var initial = nameArr[i][0];

    if (initial) {
      // only include initial if valid character
      result += nameArr[i][0];
    }

    if (result.length === 2) {
      // we only want max 2 letter initials
      break;
    }
  }

  return result.toUpperCase();
};

/**
 * Gets initials from first/last name string
 * @param {string} firstName 
 * @param {string} lastName 
 */
var getInitialsFromFirstLastName = exports.getInitialsFromFirstLastName = function getInitialsFromFirstLastName(firstName, lastName) {
  if (!firstName && !lastName) {
    return UNKNOWN;
  }

  return getInitials((firstName || '') + ' ' + (lastName || ''));
};


//////////////////
// WEBPACK FOOTER
// ./~/cw-ui-core/lib/services/InitialsService.js
// module id = 815
// module chunks = 10